import {
  BOOKING_FIELD_CHANGE,
  CHANGE_BOOKING_REDIRECT_URL,
  CHANGE_PAID_BOOKING_REDIRECT_URL,
  FIELD_CHANGE,
  PAID_BOOKING_FIELD_CHANGE,
  SUBMIT_FAIL,
  SUBMIT_SUCCESS,
} from 'publisher/actionTypes'

export const optInSuccess = () => ({
  type: SUBMIT_SUCCESS,
})

export const optInFail = errors => ({
  type: SUBMIT_FAIL,
  payload: errors,
})

export const changeField = (slug, value) => ({
  type: FIELD_CHANGE,
  payload: {
    slug,
    value,
  },
})

export const changeBookingRedirectUrl = value => ({
  type: CHANGE_BOOKING_REDIRECT_URL,
  payload: value,
})

export const changePaidBookingRedirectUrl = value => ({
  type: CHANGE_PAID_BOOKING_REDIRECT_URL,
  payload: value,
})

export const changeBookingField = (slug, value) => ({
  type: BOOKING_FIELD_CHANGE,
  payload: {
    slug,
    value,
  },
})

export const changePaidBookingField = (slug, value) => ({
  type: PAID_BOOKING_FIELD_CHANGE,
  payload: {
    slug,
    value,
  },
})

/**
 * @deprecated
 * @param slug
 * @param value
 * @returns {function(...[*]=)}
 */
export const change = (slug, value) => dispatch => {
  dispatch({
    type: FIELD_CHANGE,
    payload: { slug, value },
  })
}
